module.exports = __webpack_public_path__ + "img/live.b3100345.jpg";